let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("426Qk")).then(() => parcelRequire('4Nt6F'));